var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "InfoItem",
        {
          class: "container-item _scroll_item",
          attrs: { title: _vm.titleTxt, "default-open": false },
        },
        [
          _c(
            "el-form",
            {
              ref: "dataForm",
              staticClass: "formBox",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                size: "small",
                "label-position": "top",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: { label: _vm.$t("storeVisitReport.TRForm.TRContent") },
                },
                [
                  _c("FormTextArea", {
                    attrs: {
                      val: _vm.form.trainingInfo.trainingCourse,
                      maxlength: 150,
                      mode: _vm.mode,
                    },
                    on: {
                      "update:val": function ($event) {
                        return _vm.$set(
                          _vm.form.trainingInfo,
                          "trainingCourse",
                          $event
                        )
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.requiredFlag,
                      expression: "requiredFlag",
                    },
                  ],
                },
                [
                  _c(
                    "div",
                    { staticClass: "u-row" },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "trainingInfo.trainingDate",
                            rules: _vm.rules.chooseEmpty,
                            label: _vm.$t("storeVisitReport.TRForm.TRDate"),
                          },
                        },
                        [
                          _c("FormDatePicker", {
                            attrs: {
                              val: _vm.form.trainingInfo.trainingDate,
                              mode: _vm.mode,
                            },
                            on: {
                              "update:val": function ($event) {
                                return _vm.$set(
                                  _vm.form.trainingInfo,
                                  "trainingDate",
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "trainingInfo.trainingChannel",
                            rules: _vm.rules.chooseEmpty,
                            label: _vm.$t("storeVisitReport.TRForm.TRWay"),
                          },
                        },
                        [
                          _c("FormSelect", {
                            attrs: {
                              val: _vm.form.trainingInfo.trainingChannel,
                              options: _vm.optConfig.trainingChannelOptions,
                              mode: _vm.mode,
                            },
                            on: {
                              "update:val": function ($event) {
                                return _vm.$set(
                                  _vm.form.trainingInfo,
                                  "trainingChannel",
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "trainingInfo.trainingLocation",
                        rules: _vm.rules.iptEmpty,
                        label: _vm.$t("storeVisitReport.TRForm.TRAddress"),
                      },
                    },
                    [
                      _c("FormInput", {
                        attrs: {
                          val: _vm.form.trainingInfo.trainingLocation,
                          maxlength: 150,
                          mode: _vm.mode,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.form.trainingInfo,
                              "trainingLocation",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "trainingInfo.trainer",
                        rules: _vm.rules.iptEmpty,
                        label: _vm.$t("storeVisitReport.TRForm.trainer"),
                      },
                    },
                    [
                      _c("FormTextArea", {
                        attrs: {
                          val: _vm.form.trainingInfo.trainer,
                          maxlength: 150,
                          mode: _vm.mode,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.form.trainingInfo,
                              "trainer",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "trainingInfo.trainee",
                        rules: _vm.rules.iptEmpty,
                        label: _vm.$t("storeVisitReport.TRForm.trainee"),
                      },
                    },
                    [
                      _c("FormTextArea", {
                        attrs: {
                          val: _vm.form.trainingInfo.trainee,
                          maxlength: 150,
                          mode: _vm.mode,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.form.trainingInfo,
                              "trainee",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "trainingInfo.gyTrainerComments",
                        rules: _vm.rules.iptEmpty,
                        label: _vm.$t("storeVisitReport.TRForm.GYTComments"),
                      },
                    },
                    [
                      _c("FormTextArea", {
                        attrs: {
                          val: _vm.form.trainingInfo.gyTrainerComments,
                          maxlength: 300,
                          mode: _vm.mode,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.form.trainingInfo,
                              "gyTrainerComments",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "trainingInfo.trainingAchievement",
                        rules: _vm.rules.iptEmpty,
                        label: _vm.$t("storeVisitReport.TRForm.effAchieved"),
                      },
                    },
                    [
                      _c("FormTextArea", {
                        attrs: {
                          val: _vm.form.trainingInfo.trainingAchievement,
                          maxlength: 300,
                          mode: _vm.mode,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.form.trainingInfo,
                              "trainingAchievement",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "trainingInfo.nextTrainingPlan",
                        rules: _vm.rules.iptEmpty,
                        label: _vm.$t("storeVisitReport.TRForm.nexTPlan"),
                      },
                    },
                    [
                      _c("FormTextArea", {
                        attrs: {
                          val: _vm.form.trainingInfo.nextTrainingPlan,
                          maxlength: 300,
                          mode: _vm.mode,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.form.trainingInfo,
                              "nextTrainingPlan",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.requiredFlag,
                      expression: "!requiredFlag",
                    },
                  ],
                },
                [
                  _c(
                    "div",
                    { staticClass: "u-row" },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "trainingInfo.trainingDate",
                            rules: [],
                            label: _vm.$t("storeVisitReport.TRForm.TRDate"),
                          },
                        },
                        [
                          _c("FormDatePicker", {
                            attrs: {
                              val: _vm.form.trainingInfo.trainingDate,
                              mode: _vm.mode,
                            },
                            on: {
                              "update:val": function ($event) {
                                return _vm.$set(
                                  _vm.form.trainingInfo,
                                  "trainingDate",
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "trainingInfo.trainingChannel",
                            rules: [],
                            label: _vm.$t("storeVisitReport.TRForm.TRWay"),
                          },
                        },
                        [
                          _c("FormSelect", {
                            attrs: {
                              val: _vm.form.trainingInfo.trainingChannel,
                              options: _vm.optConfig.trainingChannelOptions,
                              mode: _vm.mode,
                            },
                            on: {
                              "update:val": function ($event) {
                                return _vm.$set(
                                  _vm.form.trainingInfo,
                                  "trainingChannel",
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "trainingInfo.trainingLocation",
                        rules: [],
                        label: _vm.$t("storeVisitReport.TRForm.TRAddress"),
                      },
                    },
                    [
                      _c("FormInput", {
                        attrs: {
                          val: _vm.form.trainingInfo.trainingLocation,
                          maxlength: 150,
                          mode: _vm.mode,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.form.trainingInfo,
                              "trainingLocation",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "trainingInfo.trainer",
                        rules: [],
                        label: _vm.$t("storeVisitReport.TRForm.trainer"),
                      },
                    },
                    [
                      _c("FormTextArea", {
                        attrs: {
                          val: _vm.form.trainingInfo.trainer,
                          maxlength: 150,
                          mode: _vm.mode,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.form.trainingInfo,
                              "trainer",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "trainingInfo.trainee",
                        rules: [],
                        label: _vm.$t("storeVisitReport.TRForm.trainee"),
                      },
                    },
                    [
                      _c("FormTextArea", {
                        attrs: {
                          val: _vm.form.trainingInfo.trainee,
                          maxlength: 150,
                          mode: _vm.mode,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.form.trainingInfo,
                              "trainee",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "trainingInfo.gyTrainerComments",
                        rules: [],
                        label: _vm.$t("storeVisitReport.TRForm.GYTComments"),
                      },
                    },
                    [
                      _c("FormTextArea", {
                        attrs: {
                          val: _vm.form.trainingInfo.gyTrainerComments,
                          maxlength: 300,
                          mode: _vm.mode,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.form.trainingInfo,
                              "gyTrainerComments",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "trainingInfo.trainingAchievement",
                        rules: [],
                        label: _vm.$t("storeVisitReport.TRForm.effAchieved"),
                      },
                    },
                    [
                      _c("FormTextArea", {
                        attrs: {
                          val: _vm.form.trainingInfo.trainingAchievement,
                          maxlength: 300,
                          mode: _vm.mode,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.form.trainingInfo,
                              "trainingAchievement",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "trainingInfo.nextTrainingPlan",
                        rules: [],
                        label: _vm.$t("storeVisitReport.TRForm.nexTPlan"),
                      },
                    },
                    [
                      _c("FormTextArea", {
                        attrs: {
                          val: _vm.form.trainingInfo.nextTrainingPlan,
                          maxlength: 300,
                          mode: _vm.mode,
                        },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.form.trainingInfo,
                              "nextTrainingPlan",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "m-actions" },
        [
          _vm.mode === "edit"
            ? [
                _c(
                  "el-button",
                  { attrs: { size: "small" }, on: { click: _vm.onSaveDraft } },
                  [_vm._v(_vm._s(_vm.$t("common.saveDraft")))]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "small" },
                    on: { click: _vm.onDraftAndGo },
                  },
                  [_vm._v(_vm._s(_vm.$t("common.nextStep")))]
                ),
              ]
            : [
                _c(
                  "el-button",
                  {
                    key: _vm.mode,
                    attrs: {
                      type: "primary",
                      size: "small",
                      disabled: _vm.mode === "error",
                    },
                    on: { click: _vm.onNext },
                  },
                  [_vm._v(_vm._s(_vm.$t("common.nextStep")))]
                ),
              ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }